// Alpine.js component initialization - each instance manages its own state

document.addEventListener('alpine:init', () => {
  // Alpine component initialization - each instance has its own state
  Alpine.data('ThemeSection_Bundle', (data = {}) => {
    
    return {
      // Instance-specific state
      bundleData: data.bundleData || [],
      selectedVariants: [],
      variantsForPurchase: [],
      selectedBundle: null,
      itemLimit: 4,
      initialized: false,
      
      init() {
        // Initialize with first bundle from this instance's data
        if (this.bundleData && this.bundleData.length > 0) {
          this.selectedBundle = this.bundleData[0];
          this.itemLimit = this.bundleData[0]?.itemLimit || 4;
          this.setInitialValues();
        }
        this.initialized = true;
        
        // Remove overflow-hidden from #MainContent (only needs to run once)
        // This is a workaround for proper layout display on page load
        if (!window.__bundleOverflowRemoved) {
          const mainContent = document.querySelector('#MainContent');
          if (mainContent) {
            mainContent.classList.remove('overflow-hidden');
            window.__bundleOverflowRemoved = true;
          }
        }
      },
      
      setInitialValues() {
        this.itemLimit = this.selectedBundle?.itemLimit || 4;
        this.selectedVariants = Array(this.itemLimit).fill({type: 'empty'});
        this.variantsForPurchase = [];
      },
      
      // Instance methods
      addVariantToBundle(variant) {
        // Check if bundle is full of products, if so, return early
        if (this.selectedVariants.every(v => v.type === 'product')) {
          return;
        }

        // Find the next empty variant and replace it with the product variant
        const emptyIndex = this.selectedVariants.findIndex(v => v.type === 'empty');
        if (emptyIndex !== -1) {
          this.selectedVariants[emptyIndex] = {
            variant: variant,
            type: 'product',
          };  
        } else {
          this.selectedVariants.push({
            variant: variant,
            type: 'product',
          });
        }
      },
      
      removeVariantFromBundle(variantId) {
        // Find the index of the variant to remove and replace it with empty
        const index = this.selectedVariants.findIndex(v => v.type === 'product' && v.variant?.id === variantId);
        if (index !== -1) {
          this.selectedVariants[index] = {
            type: 'empty',
          };
        }
        
        // After we remove the variant, we need to reorder the array so that the empty variants are at the end
        this.selectedVariants = this.selectedVariants.sort((a, b) => {
          if (a.type === 'empty') {
            return 1;
          }
          if (b.type === 'empty') {
            return -1;
          }
          return 0;
        });
      },
      
      clearBundle() {
        this.selectedVariants = Array.from({ length: this.itemLimit }, () => ({
          type: 'empty',
        }));
      },
      
      setBundleLimit(limit) {
        this.selectedBundle = this.bundleData.find(b => Number(b.itemLimit) === Number(limit));
        
        if (this.selectedBundle) {
          this.itemLimit = Number(this.selectedBundle.itemLimit);
          // Adjust selectedVariants to match new limit
          const currentProducts = this.selectedVariants.filter(v => v.type === 'product');
          const newEmptySlots = Array(Math.max(0, this.itemLimit - currentProducts.length)).fill({type: 'empty'});
          this.selectedVariants = [...currentProducts, ...newEmptySlots].slice(0, this.itemLimit);
        }
      },
      
      // Computed/getters
      get bundleCount() {
        return this.selectedVariants.filter(v => v.type === 'product').length;
      },
      
      get isBundleFull() {
        return this.selectedVariants.filter(v => v.type === 'product').length >= this.itemLimit;
      },
      
      purchaseBundle() {
        // Verify selectedBundle is available before proceeding
        if (!this.selectedBundle) {
          return;
        }
        
        const bundleId = Math.random().toString(36).substring(2, 15);
        const bundleCount = this.selectedBundle.itemLimit;
        
        // Find the parent bundle product - use the current selected bundle
        const parentProduct = this.bundleData.find(b => {
          return Number(b.itemLimit) === bundleCount;
        });
        
        if (!parentProduct) {
          return;
        }
        
        // Prepare bundle items for purchase - only include products, not empty slots
        this.variantsForPurchase = this.selectedVariants
          .filter(v => v.type === 'product')
          .map(variant => {
            return {
              id: variant.variant.id,
              quantity: 1,
              title: variant.variant.productTitle,
              parent_id: parentProduct.bundleProduct,
              original_price: variant.variant.price,
              properties: {
                _bundle: this.selectedBundle.title.toLowerCase().replace(/ /g, '-'),
                _bundle_item: true,
                [`_bundle_id`]: bundleId,
              },
            };
          });
          
        this.variantsForPurchase.push({
          id: parentProduct.bundleProduct,
          quantity: 1,
          properties: {
            _bundle_parent: true,
            _bundle_children: this.variantsForPurchase.map(v => v.title).join(','),
          },
        });

        fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-items,cart-footer,cart-item-count', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'items': this.variantsForPurchase,
          })
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          // This will work if we use the `sections` api to get the cart items
          document.body.dispatchEvent(
            new CustomEvent('shapes:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      },
      
      remainingItemsText() {
        return `Add ${this.itemLimit - this.bundleCount} more`;
      },
      
      // Component-specific display methods
      displayMobileButtonText() {
        return `View your ${this.selectedBundle?.title || 'bundle'}`;
      },
      
      displayBundlePrice() {
        return `Add To Cart - $${this.selectedBundle?.bundlePrice || '0'}`;
      },
      
      getProductTitle(variant) {
        if (variant.variant.title.toLowerCase() === 'default title') {
          return variant.variant.productTitle;
        }
        return variant.variant.title;
      },
      
      getDesktopBundlePrice(showSavings = false) {
        const selectedBundle = this.selectedBundle;
        if (!selectedBundle) return '';
        
        if (showSavings) {
          return `Add To Cart - $${selectedBundle.bundlePrice} <span class="bundle-atc-savings">${selectedBundle.bundleSavings}</span>`;
        } else {
          return `Add To Cart - $${selectedBundle.bundlePrice}`;
        }
      },
      
      getSavingsText() {
        const savingsText = this.selectedBundle?.bundleSavings;
        if (savingsText) {
          return `(savings ${savingsText})`;
        } else {
          return '';
        }
      },
      
      bundleItemCount(variantId) {
        return this.selectedVariants.filter(v => v.type === 'product' && v.variant.id === variantId).length;
      },
      
      // Alias methods for backward compatibility with template
      addVariant(variant) {
        this.addVariantToBundle(variant);
      },
      
      getProductPricing(variantPrice) {
        const usdFormatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        
        let originalPrice = usdFormatter.format(variantPrice / 100);
        let discountPrice = usdFormatter.format(variantPrice / 100);
        
        if (this.selectedBundle?.bundleDiscount) {
          // Shopify returns money as cents, so we need to convert it to dollars
          const discountPriceInCents = variantPrice - (variantPrice * (this.selectedBundle?.bundleDiscount / 100));
          // convert discountPrice to dollars
          const discountPriceInDollars = discountPriceInCents / 100;
          discountPrice = usdFormatter.format(discountPriceInDollars);
        } 
        
        return { originalPrice, discountPrice };
      },
      
      getTotalBundlePrice() {
        const usdFormatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        
        const bundleDiscount = this.selectedBundle?.bundleDiscount || 0;
        
        // get the total price of the bundle without the discount
        const totalPrice = this.selectedVariants.filter(v => v.type === 'product').reduce((acc, variant) => acc + variant.variant.price, 0);
        
        // apply the discount to the total price
        const totalPriceWithDiscount = totalPrice - (totalPrice * (bundleDiscount / 100));
        
        console.log('---- Get Total Bundle Price ----', {
          originalPrice: usdFormatter.format(totalPrice / 100),
          discountPrice: usdFormatter.format(totalPriceWithDiscount / 100),
          savings: usdFormatter.format((totalPrice / 100) - totalPriceWithDiscount / 100),
        });
        
        return {
          originalPrice: usdFormatter.format(totalPrice / 100),
          discountPrice: usdFormatter.format(totalPriceWithDiscount / 100),
          savings: usdFormatter.format((totalPrice / 100) - totalPriceWithDiscount / 100),
        }
      }
    };
  });
});
